import { useState, useEffect } from "react";
import { Col, Form, Row, Select, message } from "antd";
import "./forms.css";
import secureLocalStorage from "react-secure-storage";
import { useNavigate } from "react-router-dom";
import {
  fetchFormsThunk,
  saveSendFormsThunk,
} from "../../../store/thunks/surveyThunk";
import { useDispatch } from "react-redux";
import AddEditForm from "../../../components/molecules/Forms/addEditForm";

const SendForm = ({ onSuccess }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [form] = Form.useForm();

  const childrenList = [];

  const [forms, setForms] = useState([]);
  const [errors, setErrors] = useState([]);
  const [showLoader, setShowLoader] = useState(false);
  const [selectedValues, setSelectedValues] = useState([]);

  /* -------------------- SUBMIT HANDLER -------------------- */
  const onSubmit = async (values) => {
    const payload = {
      formName: values?.formName,
      recipients: values?.recipient,
      status: "OPEN",
      createdBy: secureLocalStorage.getItem("lIUId"),
      createdAt: new Date(
        new Date().getTime() - new Date().getTimezoneOffset() * 60000,
      )
        .toISOString()
        .slice(0, 19)
        .replace("T", " "),
    };

    try {
      await dispatch(saveSendFormsThunk(payload)).unwrap();

      setErrors([]);
      setSelectedValues([]);
      form.resetFields();

      return true;
    } catch (error) {
      let errMsg =
        error?.data?.message ||
        error?.response?.data?.message ||
        error?.message ||
        "An error occurred while creating the form";

      setErrors(errMsg);
      message.error(errMsg);

      throw error;
    }
  };

  {
    /*begin::getForms will fetch the list of Forms*/
  }
  const getForms = async () => {
    const payload = { route: "forms", action: "findAll" };

    await dispatch(fetchFormsThunk(payload))
      .unwrap()
      .then((response) => {
        const temp = [];
        response?.map((form, index) => {
          temp.push({
            label: form?.formDisplayName,
            value: form?._id,
          });
        });
        setForms(temp);
      })
      .catch((error) => {});
  };
  {
    /*end::getForms will fetch the list of Forms*/
  }

  const handleSuccess = () => {
    form.resetFields();
    setSelectedValues([]);
    if (onSuccess) {
      onSuccess();
    }
  };

  {
    /*For Recipients dropdown values in state*/
  }

  const handleChange = (value) => {
    setSelectedValues(value);
  };

  useEffect(() => {
    getForms();
  }, []);

  return (
    <AddEditForm
      form={form}
      onSubmit={onSubmit}
      onSuccess={handleSuccess}
      successMessages={{
        create: "Form created successfully",
      }}
      fields={
        <>
          <Row className="pb-16" gutter={[12, 12]}>
            <Col xs={24} sm={24} md={12} lg={12}>
              <Form.Item
                className="m-0"
                label="Form Name"
                name="formName"
                rules={[
                  { required: true, message: "Please select a form name!" },
                ]}
              >
                <Select
                  showSearch
                  allowClear
                  className=""
                  options={forms}
                  filterOption={(input, option) =>
                    (option?.label ?? "")
                      ?.toLowerCase()
                      .includes(input?.toLowerCase())
                  }
                ></Select>
              </Form.Item>
            </Col>

            <Col xs={24} sm={24} md={12} lg={12}>
              <Form.Item
                className="m-0"
                label="Recipients"
                name="recipient"
                placeholder="Please input recipient's email address"
                rules={[
                  {
                    required: true,
                    message: "Please input recipient's email address.",
                  },
                ]}
                validateStatus={errors && errors["email"] ? "error" : undefined}
                help={errors && errors["email"] ? errors["email"] : undefined}
              >
                <Select
                  showSearch
                  allowClear
                  mode="tags"
                  size={"large"}
                  placeholder="Enter Email ID's"
                  value={selectedValues}
                  onChange={handleChange}
                  filterOption={(input, option) =>
                    (option?.label ?? "")
                      ?.toLowerCase()
                      .includes(input?.toLowerCase())
                  }
                >
                  {childrenList}
                </Select>
              </Form.Item>
            </Col>
          </Row>
        </>
      }
    />
  );
};
export default SendForm;
